module.exports = __webpack_public_path__ + "media/crosses/cross--red-area-8524b98e.svg";